import React, { useCallback, useEffect } from "react";
import tagStore, { TagId } from "~/stores/tags";
import { observer } from "mobx-react";
import AsyncPaginatedSelect from "~/components/AsyncPaginatedCombobox";

interface Props {
  value: TagId[];
  onChange: (newValue: string[]) => void;
  isCreatable?: boolean;
  tagValueKey?: "id" | "label";
}

const TagSelect = observer(({ value, tagValueKey = "label", isCreatable, onChange }: Props) => {
  const fetcher = tagStore.f;
  const idToOpt = useCallback(
    (id: string | TagId) => {
      if (tagValueKey === "label") {
        return {
          label: id,
          value: id,
        };
      }
      let item = fetcher.itemsList.find((t) => (t.id || "").toString() === id.toString());
      if (!item) {
        item = fetcher.itemsList.find((t) => (t.label || "").toString() === id.toString());
      }
      if (!item) return null;
      return {
        label: item.label,
        value: item[tagValueKey],
      };
    },
    [fetcher.itemsList]
  );

  const onCreate = async (option: string) => {
    const res = await tagStore.createNewTag(option);
    if (res?.data) {
      onChange([...value, res.data[tagValueKey]]);
    }
    await tagStore.f.load("");
    return res.data;
  };

  useEffect(() => {
    tagStore.f.load("");
  }, []);
  return (
    <AsyncPaginatedSelect
      isCreatable={isCreatable ?? false}
      fetcher={tagStore.f}
      itemIdToOption={idToOpt}
      value={value}
      idKey={tagValueKey}
      onCreate={onCreate}
      onChange={onChange}
      selectProps={{
        isMulti: true,
      }}
    />
  );
});

export default TagSelect;
